import { useEffect, useState } from 'react';
import { supabase } from './supabase';

/**
 * "250+ creators have already earned on ShoutOut" (V9, Nicky 12 Oct 2026).
 * The daily count of creators with any non-bonus earnings, rounded down to 50
 * and never lower than before, read from kpi_cache through the public
 * creators_earned_display() (frontend migration
 * 20261013020000_creators_earned_count). null until known: callers show
 * nothing rather than a placeholder.
 */
export function useCreatorsEarned(): number | null {
  const [n, setN] = useState<number | null>(null);
  useEffect(() => {
    let cancelled = false;
    supabase
      .rpc('creators_earned_display')
      .then(({ data, error }) => {
        if (!cancelled && !error && typeof data === 'number' && data > 0) setN(data);
      })
      .then(undefined, () => {
        /* no number shown */
      });
    return () => {
      cancelled = true;
    };
  }, []);
  return n;
}
